// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app .currency-selection[data-v-76fa87eb]{max-width:110px}@media (min-width:320px)and (max-width:575px){#app .currency-selection[data-v-76fa87eb]{max-width:60px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
